import { Moment } from "moment";
import {
  DebitoCredito,
  Mercado,
  NegocioBMF,
  TipoOperacao,
  Trade,
} from "./enum";

interface IOperacaoLeitor {
  codigoAtivo: string;
  mercado: Mercado;
  tipoOperacao: TipoOperacao;
  quantidade: number;
  precoUnitario: number;
  daytradeSwingtrade?: Trade;

  ordem: number;
  nota: string;
  usuario: string;
  dataPregao: Moment;
}

interface IOperacaoLeitorBMF extends IOperacaoLeitor {
  prazo: Moment;
  tipoNegocio: NegocioBMF;
  taxaOperacional: number;
  valorOperacao: number;
  debitoCredito: DebitoCredito;
}

export class OperacaoLeitorBMF implements IOperacaoLeitorBMF {
  public codigoAtivo!: string;
  public mercado!: Mercado;
  public tipoOperacao!: TipoOperacao;
  public quantidade!: number;
  public precoUnitario!: number;
  public daytradeSwingtrade?: Trade;
  public prazo!: Moment;
  public tipoNegocio!: NegocioBMF;
  public taxaOperacional!: number;
  public valorOperacao!: number;
  public debitoCredito!: DebitoCredito;
  public ordem!: number;
  public nota!: string;
  public usuario!: string;
  public dataPregao!: Moment;

  constructor(param: IOperacaoLeitorBMF) {
    Object.assign(this, param);
  }
}

interface IOperacaoLeitorBovespa extends IOperacaoLeitor {
  prazo?: Moment;
  valorTotal: number;
  codigoObjeto?: string;
  isinAtivo?: string;
}

export class OperacaoLeitorBovespa implements IOperacaoLeitorBovespa {
  public codigoAtivo!: string;
  public mercado!: Mercado;
  public tipoOperacao!: TipoOperacao;
  public quantidade!: number;
  public precoUnitario!: number;
  public daytradeSwingtrade?: Trade;
  public valorTotal!: number;
  public prazo?: Moment;
  public codigoObjeto?: string;
  public isinAtivo?: string;
  public ordem!: number;
  public nota!: string;
  public usuario!: string;
  public dataPregao!: Moment;

  constructor(param: IOperacaoLeitorBovespa) {
    Object.assign(this, param);
  }
}
